import { SET_PASSENGER_TYPE_CODES, SET_PTC_LOADING } from '../../actions/flight/passengerTypeCode';

const initialState = {
  passengerTypeCodesList: [],
  isPtcLoading: false,
};

const passengerTypeCodesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PASSENGER_TYPE_CODES:
      return {
        ...state,
        passengerTypeCodesList: action.payload,
      };
    case SET_PTC_LOADING:
      return {
        ...state,
        isPtcLoading: action.payload,
      };
    default:
      return state;
  }
};

export default passengerTypeCodesReducer;
